import { render, staticRenderFns } from "./BuildingCreateWizard.vue?vue&type=template&id=3ecf76b5&scoped=true&"
import script from "./BuildingCreateWizard.vue?vue&type=script&lang=js&"
export * from "./BuildingCreateWizard.vue?vue&type=script&lang=js&"
import style0 from "./BuildingCreateWizard.vue?vue&type=style&index=0&id=3ecf76b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf76b5",
  null
  
)

export default component.exports